export enum BillCreationType {
    MANUAL = 'MANUAL',
    AUTO = 'AUTO',
    SPINWHEEL = 'SPINWHEEL',
    MONEY_MAPPER = 'MONEY_MAPPER',
}

export enum BillActivationStatus {
    ACTIVE = 'ACTIVE',
    REVIEW = 'REVIEW',
    REJECTED = 'REJECTED',
    REMOVED = 'REMOVED',
    UNKNOWN = 'UNKNOWN',
}

export enum BillingCadence {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY',
    SEMI_ANNUALLY = 'SEMI_ANNUALLY',
    ANNUALLY = 'ANNUALLY',
    YEARLY = 'YEARLY',
    UNKNOWN = 'UNKNOWN',
}

// Needs to be kept in sync with the categories in AI
export enum BillCategory {
    CHILDCARE = 'childcare',
    CREDIT_CARD_MINIMUM = 'credit_card_minimum',
    INSURANCE = 'insurance',
    LOANS = 'loans',
    OTHER = 'other',
    SUBSCRIPTIONS = 'subscriptions',
    RENT_MORTGAGE = 'rent_mortgage',
    UTILITIES = 'utilities',
}

export const BillCategoryNames: Record<BillCategory, string> = {
    [BillCategory.CHILDCARE]: 'Childcare',
    [BillCategory.CREDIT_CARD_MINIMUM]: 'Credit card minimum',
    [BillCategory.INSURANCE]: 'Insurance',
    [BillCategory.LOANS]: 'Loans',
    [BillCategory.OTHER]: 'Other',
    [BillCategory.SUBSCRIPTIONS]: 'Subscriptions',
    [BillCategory.RENT_MORTGAGE]: 'Housing',
    [BillCategory.UTILITIES]: 'Utilities',
};

export const BillCategoryPrecedence: Record<BillCategory, number> = {
    [BillCategory.RENT_MORTGAGE]: 1,
    [BillCategory.CHILDCARE]: 2,
    [BillCategory.UTILITIES]: 3,
    [BillCategory.LOANS]: 4,
    [BillCategory.INSURANCE]: 5,
    [BillCategory.SUBSCRIPTIONS]: 6,
    [BillCategory.OTHER]: 7,
    [BillCategory.CREDIT_CARD_MINIMUM]: 8,
};

export const BillingCadenceOrder: Record<BillingCadence, number> = {
    [BillingCadence.DAILY]: 1,
    [BillingCadence.WEEKLY]: 2,
    [BillingCadence.SEMI_MONTHLY]: 3,
    [BillingCadence.BI_WEEKLY]: 4,
    [BillingCadence.MONTHLY]: 5,
    [BillingCadence.QUARTERLY]: 6,
    [BillingCadence.SEMI_ANNUALLY]: 7,
    [BillingCadence.ANNUALLY]: 8,
    [BillingCadence.YEARLY]: 9,
    [BillingCadence.UNKNOWN]: 10,
};

// Helper function to get BillCategory from display name
export const getCategoryFromDisplayName = (
    displayName: string,
): BillCategory | null => {
    const reverseMapping: Record<string, BillCategory> = {
        Childcare: BillCategory.CHILDCARE,
        'Credit card minimum': BillCategory.CREDIT_CARD_MINIMUM,
        Insurance: BillCategory.INSURANCE,
        Loans: BillCategory.LOANS,
        Other: BillCategory.OTHER,
        Subscriptions: BillCategory.SUBSCRIPTIONS,
        Housing: BillCategory.RENT_MORTGAGE,
        Utilities: BillCategory.UTILITIES,
    };
    return reverseMapping[displayName] ?? null;
};
